import { SkyscannerSonarV3Api } from '@skyscanner-internal/sonar-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';
import { jhaMiddleware } from '../internals/clients/grpc/jhaMiddleware';
import {
  CreateSessionAffinityMiddleware,
  PollSessionAffinityMiddleware,
} from '../internals/clients/grpc/sessionAffinityMiddleware';

import type {
  SkyscannerSonarV3Request,
  SkyscannerSonarV3Response,
} from '@skyscanner-internal/sonar-web-http-client';

type SonarV3PollRequest = SkyscannerSonarV3Request.PollRequest;
type SonarV3PollResponse = SkyscannerSonarV3Response.PollResponse;
type SonarV3CreateSessionRequest = SkyscannerSonarV3Request.CreateSessionRequest;
type SonarV3CreateSessionResponse = SkyscannerSonarV3Response.CreateSessionResponse;

const GRPC_POLL_V3_CLIENT_NAME = 'SONAR_V3_POLL';
const GRPC_CREATE_SESSION_V3_CLIENT_NAME = 'SONAR_V3_CREATE_SESSION';
export const GRPC_SONAR_TIMEOUT_MS = 20_000;

const createSessionAffinityMiddleware = new CreateSessionAffinityMiddleware();
const pollSessionAffinityMiddleware = new PollSessionAffinityMiddleware(
  createSessionAffinityMiddleware.getRegion.bind(createSessionAffinityMiddleware),
);

export const sonarV3PollRequest = grpcFetchClientWrapper<SonarV3PollRequest, SonarV3PollResponse>(
  SkyscannerSonarV3Api.ItineraryService.Poll,
  {
    clientName: GRPC_POLL_V3_CLIENT_NAME,
    pathPrefix: '/g/sonar',
    betaInterceptors: [pollSessionAffinityMiddleware, jhaMiddleware],
    timeoutMs: GRPC_SONAR_TIMEOUT_MS,
  },
);

export const sonarV3CreateRequest = grpcFetchClientWrapper<
  SonarV3CreateSessionRequest,
  SonarV3CreateSessionResponse
>(SkyscannerSonarV3Api.ItineraryService.CreateSession, {
  clientName: GRPC_CREATE_SESSION_V3_CLIENT_NAME,
  pathPrefix: '/g/sonar',
  betaInterceptors: [createSessionAffinityMiddleware, jhaMiddleware],
  timeoutMs: GRPC_SONAR_TIMEOUT_MS,
});
